import { IGetSpaceUsedBdUseCase } from "../../../presentation/useCases/read/get_space_used_bd_use_case";
import { EspacoUtilizadoBD } from "../../models/espaco_utilizado_bd";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetSpaceUsedBdUseCase
 */

export class GetSpaceUsedBdUseCase implements IGetSpaceUsedBdUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(): Promise<EspacoUtilizadoBD> {
    const result = await this.repository.getSpaceUsedBD();
    return result;

  }
}
